import React from 'react';
import { Field } from 'react-final-form';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import { FieldValidator } from '../../../validation/validation';
import { CURRENT_ADDRESS } from '../../../constants/formFieldNames';

export default function AddressField() {
  return (
    <Field
      name={CURRENT_ADDRESS}
      format={(address) => address?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);

        return (
          <FormField
            {...input}
            error={isInvalid}
            label={<Label>Current street address</Label>}
            control={<Input {...input} />}
            description={isInvalid && <FormHelp>{error}</FormHelp>}
          />
        );
      }}
      validate={(streetAddress) => {
        const errors = new FieldValidator(streetAddress).required('Enter a street address').maxLength(60).build();

        return errors ? errors : null;
      }}
    />
  );
}
